import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
export function FinalCloseSection() {
  return <SectionWrapper id="cierre" withGlow data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-8 leading-tight" data-id="element-61">
          Tu identidad actual fue creada por{' '}
          <span className="text-gold-gradient" data-id="element-62">repetición.</span>
          <br data-id="element-63" />
          Tu nueva identidad comienza con{' '}
          <span className="italic" data-id="element-64">una decisión.</span>
        </h2>

        <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-65">
          Cada día que pasa sin tomar acción, tu subconsciente refuerza los
          mismos patrones. La misma procrastinación. El mismo autosabotaje. La
          misma frustración.
        </p>

        <p className="text-lg md:text-xl text-[#e8e6e1] leading-relaxed mb-12 max-w-2xl mx-auto font-medium" data-id="element-66">
          Pero hoy puedes elegir diferente. Hoy puedes decidir que la versión de
          ti que has sido hasta ahora{' '}
          <span className="text-[#c9a84c]" data-id="element-67">no es la versión final.</span>
        </p>

        <div className="bg-gradient-to-b from-[#0d1321] to-[#0a0e1a] border border-[#c9a84c]/20 rounded-2xl p-8 md:p-12 mb-8" data-id="element-68">
          <p className="text-[#9a9aab] text-sm uppercase tracking-[0.2em] mb-4" data-id="element-69">
            Protocolo completo
          </p>
          <div className="mb-6" data-id="element-70">
            <span className="text-[#6b6b7b] text-lg line-through mr-3" data-id="element-71">
              $297 USD
            </span>
            <span className="font-display text-5xl md:text-6xl font-bold text-gold-gradient" data-id="element-72">
              $27
            </span>
            <span className="text-[#e8e6e1] text-lg ml-1" data-id="element-73">USD</span>
          </div>

          <CTAButton size="large" data-id="element-74">Acceder ahora</CTAButton>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-[#6b6b7b] text-sm" data-id="element-75">
            <span data-id="element-76">✓ Acceso inmediato</span>
            <span className="hidden sm:inline" data-id="element-77">·</span>
            <span data-id="element-78">✓ Pago único</span>
            <span className="hidden sm:inline" data-id="element-79">·</span>
            <span data-id="element-80">✓ Acceso de por vida</span>
          </div>
        </div>

        <p className="text-[#6b6b7b] text-sm italic" data-id="element-81">
          "El mejor momento para plantar un árbol fue hace 20 años. El segundo
          mejor momento es ahora."
        </p>
      </div>
    </SectionWrapper>;
}